import { getAuth, signInWithPopup, GoogleAuthProvider, onAuthStateChanged, User, setPersistence, browserLocalPersistence } from 'firebase/auth';
import { app } from './firebase/config';
import { useStore } from './store';
import { subscribeToApiKeys } from './firebase/apiKeys';

const auth = getAuth(app);
const provider = new GoogleAuthProvider();

setPersistence(auth, browserLocalPersistence);

export const signInWithGoogle = async () => {
  try {
    const result = await signInWithPopup(auth, provider);
    return result.user;
  } catch (error: any) {
    console.error('Error signing in with Google:', error);
    throw new Error(error.message || 'Failed to sign in with Google');
  }
};

export const initializeAuth = () => {
  onAuthStateChanged(auth, (user) => {
    useStore.getState().setUser(user);
    
    if (user) {
      // Set up real-time listener for API keys with proper error handling
      const unsubscribe = subscribeToApiKeys(
        user.uid,
        (keys) => {
          if (keys) {
            useStore.getState().setApiKeys(keys);
          }
        },
        (error) => {
          console.error('API keys sync error:', error);
          // Don't clear existing keys on error, just notify the user
          useStore.getState().setApiKeysError(error.message);
        }
      );
      
      useStore.getState().setApiKeysUnsubscribe(unsubscribe);
    } else {
      // Clean up subscriptions when user signs out
      const unsubscribe = useStore.getState().apiKeysUnsubscribe;
      if (unsubscribe) {
        unsubscribe();
        useStore.getState().setApiKeysUnsubscribe(null);
      }
      useStore.getState().setApiKeys(null);
    }
  });
};

export const getCurrentUser = (): User | null => {
  return auth.currentUser;
};

export const signOut = async () => {
  try {
    await auth.signOut();
    useStore.getState().setUser(null);
    useStore.getState().setApiKeys(null);
    useStore.getState().setApiKeysError(null);
  } catch (error) {
    console.error('Error signing out:', error);
    throw error;
  }
};